// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__KaYPg","wrapperMain":"Carousel_wrapperMain__zMp9y"};